<template>
    <div class="mt-3">
        <span class="lbl-deal-title mt-4">E-mail</span>            
        <div class="row py-2">
            <div class="col-md-12 mb-3">
                <span class="lbl-edit">Configure aqui o assunto e corpo das mensagens para o e-mail na rotina especificada.</span>
            </div>
            <div class="col-md-12 mb-3">
                <v-button label="Configuração de E-mail" :nb-btdef="true" @click="handleNewMail"></v-button>
            </div>
            <div class="col-md-12 d-flex align-items-center ml-n2" v-for="(mail, i) in parametros.emails" :key="i">
                <form-field v-model="mail.assunto" type="text" label="Título da Página" col="5" :disabled="true"></form-field>
                <form-field v-model="mail.corpo" type="text" label="Título para Rodapé" col="3" :disabled="true"></form-field>
                <button class="btn btn-secondary mr-3" title="Configurar Página" @click="handleEditMail(i)"><i class="fa fa-cog"></i></button>
                <button class="btn btn-danger" title="Configurar Página" @click="handleCancelMail(i)"><i class="fa fa-trash"></i></button>
            </div>
        </div>

        <!-- MODAL ADICIONAR E-MAIL -->
        <div class="nb-modal-scrollable" v-if="showModalMail" @keyup.esc="closeForm()">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-header">
                    <h5>Configuração de E-mail Automático</h5>
                    <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="nb-modal-scrollable-body">
                    <div class="container">
                        <div class="row">
                            <form-field v-model="mail.tipo" type="select" label="Tipo" col="12" :selectOptions="mailOptions"></form-field>
                        </div>
                        <div class="row">
                            <form-field v-model="mail.assunto" type="text" label="Corpo do e-mail" col="12"></form-field>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <wysiwyg v-model="mail.corpo" />
                            </div>
                        </div>
                    </div>                    
                </div>
                <div class="nb-modal-scrollable-footer mt-4">
                    <v-button ref="btnConfirm" label="Salvar" title="" :nb-btdef="true"  @click="handleSaveMail(mail)"></v-button>
                    <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm()"></v-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        parametros: ''
    },
    data(){
        return{
            mail: {},
            indexUpdate: null,
            showModalMail: false,
            mailBackup: {},
            mailOptions: [
                {id: 'BV', text: 'Boas Vindas'},
                {id:'PA', text: 'Pagamento Aprovado'},
                {id: 'PN', text: 'Pagamento Não Aprovado'}
            ]
        }
    },
    methods:{
        handleNewMail(){
            this.showModalMail = true
            this.mail = {}
        },
        closeForm(){
            this.showModalMail = false
        },
        handleCancelMail(index){
            this.$emit('deleteMode', index);
        },
        handleSaveMail(mail){
            const index = this.indexUpdate
            if (index != null){
                this.$emit('editMode', {mail: mail, index:index})
                this.indexUpdate = null
                this.mailBackup = {}
            } else{
                this.$emit('insertMode', mail)
            }
                this.closeForm()
        },
        handleEditMail(index){
            this.mail = {...this.parametros.emails[index]}
            this.indexUpdate = index
            this.showModalMail = true
            
        }
    },
    created(){
        console.log(this.parametros)
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-loja/config-mail-loja.vue